import {type ZodString} from 'zod';
import {SchemaValidationErrorLabel} from '../locales';

const URL_REGEX =
	// eslint-disable-next-line security/detect-unsafe-regex
	/^(http|https|:\/\/|\.|@){2,}(localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}|\S*:\w*@)*([a-zA-Z]|(\d{1,3}|\.){7}){1,}(\w|\.{2,}|\.[a-zA-Z]{2,3}|\/|\?|&|:\d|@|=|\/|\(.*\)|#|-|%)*$/;

export const refineUrl = (s: ZodString) =>
	s.refine(
		(v) => {
			return !v || URL_REGEX.test(v);
		},
		{message: SchemaValidationErrorLabel.INVALID_VALUE},
	);
